import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { t } from '@lingui/macro'
import type { MaternityAttendanceRow, MissingExamsRow } from '@/core/api/statistics'
import { MaternityAttendanceTable } from './MaternityAttendanceTable'
import { TrimesterTable } from './TrimesterTable'
import { MissingExamsTable } from './MissingExamsTable'

type Props = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  maternityAttendance: { data?: MaternityAttendanceRow[]; isLoading: boolean; error?: unknown }
  missingExams: { data?: MissingExamsRow[]; isLoading: boolean; error?: unknown }
  isMobile: boolean
  multiEstablishment: boolean
}

export function MaternitySection({
  isExpanded, onChange, maternityAttendance, missingExams, isMobile, multiEstablishment,
}: Props) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: false } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          {t`Maternity`}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Attendance by age group`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <MaternityAttendanceTable
                data={maternityAttendance.data}
                isLoading={maternityAttendance.isLoading}
                error={maternityAttendance.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Pregnancy trimester distribution`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <TrimesterTable
                data={maternityAttendance.data}
                isLoading={maternityAttendance.isLoading}
                error={maternityAttendance.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Missing exams`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <MissingExamsTable
                data={missingExams.data}
                isLoading={missingExams.isLoading}
                error={missingExams.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
